module.exports = __webpack_public_path__ + "static/media/zopa_big_logo.5e8812e3.png";